import * as React from "react";
import {cx} from "emotion";

import "./payments-section.scss";

import {cs}               from "@Common/react/chain-services";
import {Static2}          from "@Common/react/static-2";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";

import {groupSections} from "../common/group-sections";

import {CorporateBillingAccounts} from "./corporate-billing-accounts";
import {CreditCardsOnFile}        from "./credit-cards-on-file/credit-cards-on-file";

export const PaymentsSection = ({store, summary, next}) => cs(

    ["corporateBillingAccounts", (_, next) => CorporateBillingAccounts({
        store,
        summary,
        next,
    })],
    ["creditCards", (_, next) => CreditCardsOnFile({
        store,
        remainingAmount: summary.remain,
        next,
    })],

    ({corporateBillingAccounts, creditCards}) => next({

        ...groupSections([corporateBillingAccounts, creditCards]),
        selectedCards: creditCards.selectedCards,

        render: ({showErrors}) => (
            <div className="payments payments-section-788">
                <div className="header">
                    <div className="title">
                        Payment
                    </div>
                    <div className="sub-title" xd-qa-type="label" xd-qa-name="Payments Description">
                        Select your method(s) of payment
                    </div>
                </div>

                {corporateBillingAccounts.render({
                    className: "card",
                    showErrors: showErrors.value,
                })}
                {creditCards.render({
                    className: "card",
                    showErrors,
                })}


            </div>
        ),
    })
);

